var render, staticRenderFns
import script from "./event-detail.vue?vue&type=script&lang=js"
export * from "./event-detail.vue?vue&type=script&lang=js"
import style0 from "./event-detail.vue?vue&type=style&index=0&id=4d8ddad8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports